// /**
//  * Warehouse - Add User
//  */

// React
import React, {FunctionComponent, useEffect, useState} from 'react';

import {useForm} from 'react-hook-form';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../redux/reducers';
import {updateWarehouseAdminActions} from '../warehouses/actions';
import {getUsersAction, createUserActions} from '../users/actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectUsersList,
  makeSelectLoading,
  makeSelectError,
} from '../users/selectors';
import {makeSelectWarehouse} from '../warehouses/selectors';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Button,
  Grid,
  InputBase,
  IconButton,
  ClickAwayListener,
  Typography,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiMagnify,
  mdiPlus,
  mdiArrowRight,
  mdiAccountPlusOutline,
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiAccountKeyOutline,
} from '@mdi/js';

// Components
import ListUser from './list-users';
import RenderFilter from '../../utils/listDaynamicFilter';
import Add from '../users/componets/add';
import Modal from '../../components/Modal';

// Helper
import {removeEmptyValueObject} from '../../utils/helpers';

// Type
// import {PayloadUpdate} from './interfaces';
import {User, PayloadCreate} from '../users/interfaces';
import {SelectorPropsAssignUser, PropsAssignUser} from './interfaces';
import type {Filter} from '../../utils/listDaynamicFilter';
import {PayloadUpdate} from '../warehouses/interfaces';

type Inputs = {
  'name.contains': string;
};

// StyleExpansionPanel
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const AddUser: FunctionComponent<PropsAssignUser> = (
  props: PropsAssignUser
) => {
  const classes = useStyles();
  const {register, handleSubmit} = useForm<Inputs>();
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({} as any);
  const [openFilterBox, setOpenFilterBox] = useState(false as boolean);
  const [openAdd, setOpenAdd] = useState(false as boolean);

  useEffect(() => {
    getUsers();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const getUsers = () => {
    props.getUsersDispatch({
      ...removeEmptyValueObject(filtersValues),
      'role.equals': 'WAREHOUSE_ADMIN',
      'warehousesId.specified': false,
    });
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام کاربر',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'phoneNumber.contains',
        label: 'شماره همراه کاربر',
        icon: mdiPhoneOutline,
      },
      {
        type: 'number',
        id: 'id.equals',
        label: 'کد کاربر',
        icon: mdiAccountKeyOutline,
      },
    ]);
  };

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    setOpenFilterBox(false);
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
        'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };
  const handleClose = () => {
    setOpenAdd(false);
  };

  return (
    <>
      <Grid container spacing={6}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography variant="h6" component={'span'}>
            {`اختصاص کاربر به انبار
            ${props.warehouse.name}
            
            `}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.searchBox}>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.input}>
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
              >
                <Icon
                  path={mdiMagnify}
                  size={1}
                  className={classes.magnifyIcon}
                />
              </IconButton>
              <InputBase
                className={classes.input}
                name="name.contains"
                placeholder="نام کاربر "
                inputRef={register({required: true})}
                inputProps={{'aria-label': 'search google maps'}}
              />
            </form>
            <ClickAwayListener onClickAway={handleClickAway}>
              <div>
                <Button
                  type="button"
                  onClick={handleClick}
                  className={classes.iconButton}
                  aria-label="search"
                >
                  {/* {checkMatchMedia('(max-width: 1024px)') ? (
                    <Icon path={mdiFilter} size={1} />
                  ) : (
                    ' جست‌وجوی پیشرفته'
                  )} */}
                  فیلترها
                </Button>
                {openFilterBox ? (
                  <div
                    className={clsx(classes.filterBox, {
                      [classes.filterOpen]: openFilterBox,
                    })}
                  >
                    <RenderFilter
                      filters={filters}
                      onFilter={(filtervalues: any) => {
                        setFiltersValues({
                          ...removeEmptyValueObject(filtervalues),
                          page: 0,
                          size: 10,
                        });
                        setOpenFilterBox(false);
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </ClickAwayListener>
          </div>
        </Grid>

        <Grid xs={6} item container alignItems="center">
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>

        <Grid container item xs={6} direction="row-reverse">
          <Button
            variant="contained"
            color="secondary"
            size="large"
            startIcon={<Icon path={mdiPlus} size={1} />}
            onClick={() => {
              setOpenAdd(true);
            }}
          >{`ایجاد کاربر جدید`}</Button>
        </Grid>
        <Grid item xs={12}>
          <ListUser
            warehouseId={props.match.params?.id}
            data={props.users}
            hasSelectUser
            updateWarehouseAdminDispatch={props.updateWarehouseAdminDispatch}
          />
        </Grid>
      </Grid>

      <Modal
        onClose={handleClose}
        open={openAdd}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiAccountPlusOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <Add
            onClose={handleClose}
            error={props.error}
            createUser={async (body: User, callback: () => void) => {
              await props.createUserDispatch({
                body,
                pagination: {
                  ...filtersValues,
                  'role.equals': 'WAREHOUSE_ADMIN',
                  'warehousesId.specified': false,
                },
                callback,
              });
            }}
          />
        }
      />
    </>
  );
};

const mapStateToProps = createStructuredSelector<
  Store,
  SelectorPropsAssignUser
>({
  users: makeSelectUsersList(),
  warehouse: makeSelectWarehouse(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getUsersDispatch: (payload: object) => dispatch(getUsersAction(payload)),
    updateWarehouseAdminDispatch: (payload: PayloadUpdate) =>
      dispatch(updateWarehouseAdminActions(payload)),
    createUserDispatch: (payload: PayloadCreate) =>
      dispatch(createUserActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(AddUser);
